import React from 'react';
import checked from "../../../../common/assets/icons/status-checked.svg";
import notChecked from "../../../../common/assets/icons/status-not-checked.svg";
import chevron from "../../../../common/assets/icons/chevron.svg";
import styles from './RegFormsLink.module.scss';
import {useRegFormsContext} from "../RegFormsContext";

export interface RegFormsLinkProps {
  status: boolean
  label: React.ReactNode
  text: React.ReactNode
  link: string
  disabled?: boolean
}

const RegFormsLink = ({status, label, text, link, disabled}: RegFormsLinkProps) => {
  const {showMessageFillPersonalInfo} = useRegFormsContext();
  const LinkContent = () => {

    return (
      <>
        <div className={styles.iconStatusContainer}>
          {status
            ? <img src={checked} alt="checked" className={styles.iconStatus}/>
            : <img src={notChecked} alt="notChecked" className={styles.iconStatus}/>
          }
        </div>
        <div className={styles.label}>{label}</div>
        <div className={styles.text}>{text}</div>
        <div className={styles.iconLinkContainer}>
          <img src={chevron} alt="link" className={styles.iconLink}/>
        </div>
      </>
    )
  };

  return !disabled
    ? (
    <a
      href={link}
      target={'_self'}
      className={styles.linkContainer}
    >
      <LinkContent/>
    </a>
  ) : (
    <div
      className={styles.linkContainer}
      onClick={showMessageFillPersonalInfo}
    >
      <LinkContent/>
    </div>
    );
};

export default RegFormsLink;
